import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function FirstTwistRow() {
   return (
      <InputRangeRow
         titleProp={"First Twist"}
         descriptionProp={"t/m"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={0}
         maxProp={999}
         propertyNameProp={"firstTwist"}
         errorDialogueProp={"0-999 only"}
         floatProp={false}
      />
   );
}
